import { createTheme } from '@mui/material/styles';

// App theme based on provided palette
// Colors: #7522D1, #F4EBFF, #030007, #4F4937, #42374F, #FFFFFF
const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#7522D1',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#42374F',
            contrastText: '#FFFFFF',
        },
        background: {
            default: '#F4EBFF',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#030007',
            secondary: '#4F4937',
        },
        common: {
            white: '#FFFFFF',
            black: '#030007',
        },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiIconButton: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiButton: {
            defaultProps: {
                disableRipple: true,
                size: 'small',
            },
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 700,
                    padding: '8px 16px',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 12px rgba(117, 34, 209, 0.2)',
                    },
                },
                containedPrimary: {
                    background: 'linear-gradient(135deg, #7522D1 0%, #8B5CF6 100%)',
                    '&:hover': {
                        background: 'linear-gradient(135deg, #621bb3 0%, #7c4ee4 100%)',
                    },
                },
                outlinedPrimary: {
                    borderColor: 'rgba(117, 34, 209, 0.5)',
                    color: '#7522D1',
                    '&:hover': {
                        backgroundColor: 'rgba(117, 34, 209, 0.04)',
                        borderColor: '#7522D1',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    backgroundColor: '#FFFFFF',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#7522D1',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#7522D1',
                        borderWidth: '1.5px',
                    },
                },
                notchedOutline: {
                    borderColor: 'rgba(117, 34, 209, 0.12)',
                    transition: 'border-color 0.2s ease-in-out',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '0.85rem',
                    color: '#6B7280',
                    '&.Mui-focused': {
                        color: '#7522D1',
                        fontWeight: 600,
                    },
                },
            },
        },
        MuiTab: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiMenuItem: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    fontSize: '0.875rem',
                    borderRadius: '6px',
                    margin: '2px 6px',
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(117, 34, 209, 0.08)',
                        color: '#7522D1',
                        fontWeight: 600,
                        '&:hover': {
                            backgroundColor: 'rgba(117, 34, 209, 0.12)',
                        },
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiSelect: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiAutocomplete: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiFormControl: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {    
                    border: "1px solid rgba(117, 34, 209, 0.08)",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 20px rgba(117, 34, 209, 0.03)",
                },
            },
        },
    },
});

export default theme;

